
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyCX_o3740Q_POZBlGQ2BTREd-clfA7uxyI',
  authDomain: 'papayum.firebaseapp.com',
  databaseURL: 'https://papayum.firebaseio.com',
  projectId: 'papayum',
  storageBucket: 'papayum.appspot.com',
  messagingSenderId: '976238878737',
  appId: '1:976238878737:web:1b923d52caab6764b2d1b0'
}
// Initialize your firebase app
firebase.initializeApp({
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId
})
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    console.log('user sign in', user)
  } else {
    console.log('user sign out', user)
  }
})
firebase.auth().signInAnonymously().catch((error) => {
  console.log(error)
})
export const db = firebase.firestore()



// WEBPACK FOOTER //
// ./src/assets/js/firestore.js